import { Component, inject, signal } from '@angular/core';
import { PlanthunterService } from '../../service/planthunter.service';

@Component({
    selector: 'planthunter-amountofnewhunts-component',
    styleUrls: ['planthunter.component.scss'],
    template: `@if (newHunts() > 0) {
  <span class="planthunter-nav-count">{{
    newHunts()
  }}</span>
}`,
    standalone: true
})
export class PlanthunterAmountOfNewHuntsComponent {
  private planthunterService = inject(PlanthunterService);

  readonly newHunts = signal<number>(0);

  constructor() {
    this.planthunterService
      .getAmountOfNewPlanthunterItems()
      .then((amountOfNewPlanthunterItems) => {
        this.newHunts.set(amountOfNewPlanthunterItems);
      });
  }
}
